<script setup>
import { ref } from 'vue'
import { router } from '@inertiajs/vue3'
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
const props = defineProps({ property: { type: Object, required: true } })
const emit  = defineEmits(['close'])

const form = ref({ start_on: '', end_on: '', reason: '' })
const processing = ref(false)

function submit() {
  if (!form.value.start_on || !form.value.end_on) return
  processing.value = true
  router.post(`/properties/${props.property.id}/blackouts`, { blackout: form.value }, {
    preserveScroll: true,
    onFinish: () => { processing.value = false },
    onSuccess: () => emit('close')
  })
}
</script>

<template>
  <div
    class="overlay"
    @click.self="emit('close')"
  >
    <div class="modal">
      <h2 class="modal__title">
        {{ t('host_portal.property.blackout_modal.title') }}
      </h2>
      <p class="modal__sub">
        {{ t('host_portal.property.blackout_modal.sub') }}
      </p>
      <form @submit.prevent="submit">
        <label class="field">
          <span class="label">{{ t('host_portal.property.blackout_modal.start_on') }}</span>
          <input
            v-model="form.start_on"
            type="date"
            required
            class="input"
          >
        </label>
        <label class="field">
          <span class="label">{{ t('host_portal.property.blackout_modal.end_on') }}</span>
          <input
            v-model="form.end_on"
            type="date"
            required
            class="input"
          >
        </label>
        <label class="field">
          <span class="label">{{ t('host_portal.property.blackout_modal.reason') }}</span>
          <input
            v-model="form.reason"
            type="text"
            class="input"
          >
        </label>
        <div class="actions">
          <button
            type="button"
            class="btn"
            @click="emit('close')"
          >
            {{ t('host_portal.property.blackout_modal.cancel') }}
          </button>
          <button
            type="submit"
            class="btn btn--primary"
            :disabled="processing"
          >
            {{ processing ? t('host_portal.property.blackout_modal.saving') : t('host_portal.property.blackout_modal.save') }}
          </button>
        </div>
      </form>
    </div>
  </div>
</template>

<style scoped>
.overlay {
  position: fixed; inset: 0; z-index: 50; background: color-mix(in oklch, black 50%, transparent);
  display: grid; place-items: center; padding: 1rem;
}
.modal {
  background: var(--surface); border: 1px solid var(--line); border-radius: 0.75rem;
  padding: 1.5rem; max-width: 28rem; width: 100%;
}
.modal__title { font-size: 1.125rem; font-weight: 700; color: var(--ink); margin: 0 0 0.25rem; }
.modal__sub   { color: var(--inkSoft); margin: 0 0 1rem; font-size: 0.875rem; }
.field { display: block; margin-bottom: 0.875rem; }
.label { display: block; font-size: 0.8125rem; color: var(--inkSoft); margin-bottom: 0.25rem; }
.input {
  width: 100%; padding: 0.5rem 0.75rem; background: var(--surface);
  border: 1px solid var(--line); border-radius: var(--radius-input, 8px);
  color: var(--ink); font-size: 0.9375rem;
}
.input:focus { outline: 2px solid var(--accent); outline-offset: 1px; }
.actions { display: flex; gap: 0.5rem; justify-content: flex-end; margin-top: 1rem; }
.btn { padding: 0.5rem 0.9rem; border: 1px solid var(--line); background: var(--surface); color: var(--ink); border-radius: var(--radius-button, 8px); cursor: pointer; font-size: 0.875rem; }
.btn--primary { background: var(--accent); color: var(--accentInk); border-color: var(--accent); }
.btn--primary:disabled { opacity: 0.5; cursor: not-allowed; }
</style>
